import { Vote, Layers, Coins } from "lucide-react";
import { NavLink } from "./NavLink";

interface NavLinksProps {
  isActive: (path: string) => boolean;
}

export function NavLinks({ isActive }: NavLinksProps) {
  return (
    <div className="hidden items-center gap-1 md:flex">
      <NavLink href="/votes" active={isActive("/votes")}>
        <Vote size={16} />
        Avaliar
      </NavLink>
      <NavLink href="/submissions" active={isActive("/submissions")}>
        <Layers size={16} />
        Avaliações
      </NavLink>
      <NavLink href="/paid_credits" active={isActive("/paid_credits")}>
        <Coins size={16} />
        Créditos
      </NavLink>
    </div>
  );
}
